/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * PHRMPC.Manning.Web.API | v1
 * OpenAPI spec version: 1.0.0
 */
import { z as zod } from 'zod';

export const IFormFile = zod.instanceof(File);

export type IFormFile = zod.input<typeof IFormFile>;
export type IFormFileOutput = zod.output<typeof IFormFile>;
